import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 担当得意先情報の検索
 */
export function SearchUserCustomer(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchUserCustomer,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 担当得意先情報の変更
 */
export function UpdateUserCustomer(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateUserCustomer,data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


